import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { of, from, Observable } from 'rxjs';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AsyncValidatorFn, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { QuotationInfo } from '../model/QuotationInfo.model';
import { EmpInfo } from '../model/emp.model';
import { TenantAddressInfo } from '../model/TenantAddressInfo.model';
import { CompanyInfo } from '../model/company.model';
import { CompanyAddressInfo } from '../model/CompanyAddressInfo.model';
import { QuotationCompanyAddressInfo } from '../model/QuotationCompanyAddressInfo.model';
import { ProductInfo } from '../model/ProductInfo.model';
import { UomInfo } from '../model/UomInfo.model';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { AssetCategoryInfoInfo } from '../model/AssetCategoryInfoInfo.model';
import { AssetTypeInfo } from '../model/AssetTypeInfo.model';
import { QuotationProductInfo } from '../model/QuotationProductInfo.model';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { formatDate } from '@angular/common';
import { Subscription } from 'rxjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { env } from 'process';

@Component({
  selector: 'app-quotation-management',
  templateUrl: './quotation-management.component.html',
  styleUrls: ['./quotation-management.component.css']
})
export class QuotationManagementComponent implements OnInit {
  form: FormGroup;

  baseurl: string;
  loading: boolean = false;

  _EmpCode: string = '';
  _RoleCode: string = '';
  detailmodal: string = '';

  isOnUpdateQuotation: boolean = false;
  isSubmitted: any;

  txtSearchQuotationNo: string = '';
  txtSearchCompanyCode: string = '';
  txtSearchValidDateFrom: string = '';
  txtSearchValidDateTo: string = '';
  txtSearchCreateDateFrom: string = '';
  txtSearchCreateDateTo: string = '';

  UomList: UomInfo[] = [];
  AssetCategoryList: AssetCategoryInfoInfo[] = [];
  AssetTypeList: AssetTypeInfo[] = [];
  AssetTypeListFromSearchProduct: AssetTypeInfo[] = [];
  UserLoginList: EmpInfo[] = [];

  // Main Quotation
  QuotatonList: QuotationInfo[] = [];
  TenantAddressList: TenantAddressInfo[] = [];
  CompanyList: CompanyInfo[] = [];
  CustomerAddressList: CompanyAddressInfo[] = [];
  ProductList: ProductInfo[] = [];
  SelectedProductList: QuotationProductInfo[] = []; // ใช้กับการ Push product Master เข้า QuotationProduct
  QuotationCompanyAddressList: QuotationCompanyAddressInfo[] = [];
  QuotationProductList: QuotationProductInfo[] = [];
  ProjectSaleList: ProjectSaleInfo[] = [];

  currentPageNumberQuotation: number = 1;
  totalPagesQuotation: number
  totalItems: number = 0

  currentQuotationId: number;

  TenantID: number;
  TenantAddressItem: string = '';
  TenantSubDistrictItem: string = '';
  TenantDistrictItem: string = '';
  TenantProvinceItem: string = '';
  TenantPostCodeItem: string = '';
  hidCompanyID: number;
  hidCompanyAbbreviation: string = '';
  CompanyAddressItem: string = '';
  CompanySubDistrictItem: string = '';
  CompanySubDistrictCodeItem: string = '';
  CompanyDistrictItem: string = '';
  CompanyDistrictCodeItem: string = '';
  CompanyProvinceItem: string = '';
  CompanyProvinceCodeItem: string = '';
  CompanyPostCodeItem: string = '';

  ProductGroupShow: string = '';
  ProductCategoryCode: string = '';
  ProductTypeCode: string = '';
  ProductCategoryShow: string = '';
  ProductTypeShow: string = '';
  txtSearchProductCode: string = '';
  txtSearchProductName: string = '';
  txtSearchProductLicensePlate: string = '';
  txtSearchProductChassisNo: string = '';
  SearchProductCategory: string = null;
  SearchProductType: string = null;

  currentPageNumberPrduct: number = 1;
  totalPagesProduct: number;

  showAddressError: boolean = false;
  showProductListError: boolean = false;

  searchCustomerText: string = '';
  showCustomerDropdown: boolean = false;
  filteredCustomerList: any[] = [];
  selectedCustomerCode: string | null = null;

  returnInsQuotationID: number;

  @ViewChild('chkAllProduct', { static: false }) chkAllProduct: ElementRef;
  @ViewChild('chkAllProduct', { static: false }) chchkAllProductkAllContact: ElementRef;

  ActiveList = [
    { ActiveCode: 'Y', ActiveName: 'Yes' },
    { ActiveCode: 'N', ActiveName: 'No' }
  ];

  // Auto Complete Search แปลงจาก input type text
  searchCustomerAutoText: string = '';
  filteredCustomerAutoList: any[] = [];
  showCustomerAutoDropdown: boolean = false;
  selectedAutoCustomer: any = null;
  // Auto Complete Search แปลงจาก input type text

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;
  }

  async ngOnInit(): Promise<void> {
    this._EmpCode = localStorage.getItem("EmpCode");
    this._RoleCode = localStorage.getItem("EmpRoleCode");

    this.form = this.formBuilder.group({
      QuotationNo: [null],
      QuotationValidDate: [null, Validators.required],
      QuotationProjectSaleID: [null]
    });

    await this.LoadCompanyList();
    await this.LoadQuotatonList("Y");
    await this.LoadUserLoginList();
    await this.LoadProjectSaleList();
    await this.LoadAssetCategoryList();

    this.form.get('QuotationProjectSaleID')?.valueChanges.subscribe(async selectedValue  => {
      let assetcategorycode = '';
      let assettypecode = '';
      //console.log('QuotationProjectSaleID value:', selectedValue );

      if (selectedValue) {
        const foundItem = this.ProjectSaleList.find(x => x.ProjectSaleId === selectedValue);

      if (foundItem) {
        assetcategorycode = foundItem.ProjectSaleAssetCategoryCode;
        assettypecode = foundItem.ProjectSaleAssetTypeCode;
        //console.log('Found details:', assetcategorycode + ' ' + assettypecode);

        await this.LoadAssetTypeList(assetcategorycode, assettypecode);
      } else {
        console.warn('Item not found in ProjectSaleList for ID:', selectedValue);
      }
      } else {
        // กรณีที่ค่าเป็น null (เช่น เลือก "Please Select")
        console.log('No item selected (value is null).');
      }
    });
  }

  async LoadQuotatonList(bySearch: string | null = null) {
    this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (bySearch === "Y") {
        this.currentPageNumberQuotation = 1;
      }

      const objectjson = {
        QuotationNo: this.checkUndefinedString(this.txtSearchQuotationNo?.trim()),
        QuotationCompanyCode: this.checkUndefinedString(this.txtSearchCompanyCode?.trim()),
        QuotationValidDateFrom: this.checkUndefinedString(this.txtSearchValidDateFrom),
        QuotationValidDateTo: this.checkUndefinedString(this.txtSearchValidDateTo),
        QuotationCreateDateFrom: this.checkUndefinedString(this.txtSearchCreateDateFrom),
        QuotationCreateDateTo: this.checkUndefinedString(this.txtSearchCreateDateTo),
        rowFetch: environment.PageSize,
        rowOFFSet: ((this.currentPageNumberQuotation - 1) < 0 ? 0 : (this.currentPageNumberQuotation - 1)) * environment.PageSize
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Quotation/GetQuotation",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.QuotatonList = response;
      this.totalItems = this.QuotatonList.length;

      if (this.QuotatonList.length <= 0) {
        this.currentPageNumberQuotation = 0;
      } else {
        if (this.currentPageNumberQuotation == 0) this.currentPageNumberQuotation = 1;
        this.totalItems = Number(this.QuotatonList[0].itemTotal);
      }

      this.totalPagesQuotation = Math.ceil(this.totalItems / environment.PageSize);
    } catch (error) {
      console.error('Error loading quotation:', error);
      alert('An error occurred while loading quotation data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  OnLoadQuotationList(target = null) {
    if (target != null) {
      this.currentPageNumberQuotation = target.currentPageNumber;
      this.totalPagesQuotation = target.totalPages;
    }

    this.LoadQuotatonList();
  }

  btnClick_SearchQuotationList() {
    this.LoadQuotatonList("Y");
  }

  ClearSearchQuotation() {
    this.txtSearchQuotationNo = "";
    this.txtSearchCompanyCode = "";
    this.txtSearchValidDateFrom = "";
    this.txtSearchValidDateTo = "";
    this.txtSearchCreateDateFrom = "";
    this.txtSearchCreateDateTo = "";

    this.searchCustomerAutoText = ""; // Clear input text on Auto Complete ของ => [NgModel] = txtSearchCompanyCode

    this.LoadQuotatonList("Y");
  }

  async LoadUserLoginList(bySearch: string | null = null) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (bySearch === "Y") {
        this.currentPageNumberQuotation = 1;
      }

      const objectjson = {
        EmpCode: this.checkUndefinedString(this._EmpCode?.trim()),
      };

      const response = await this.httpClient.post<any>(this.baseurl + "UserLogin/getUserLogin",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.UserLoginList = response;

      if (this.UserLoginList.length > 0) {
        this.TenantID = this.UserLoginList[0].TenantID;

        if (this.TenantID) {
          await this.LoadTenantAddress(this.TenantID);
        }
      }

    } catch (error) {
      console.error('Error loading userlogin:', error);
      alert('An error occurred while loading userlogin data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  async LoadTenantAddress(tenantid: number | null = null) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        TenantID: tenantid
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Tenant/GetTenantAddress",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.TenantAddressList = response;

      if (this.TenantAddressList.length > 0) {
        this.TenantAddressItem = this.TenantAddressList[0].TenantAddress;
        this.TenantSubDistrictItem = this.TenantAddressList[0].TenantSubDistrictName;
        this.TenantDistrictItem = this.TenantAddressList[0].TenantDistrictName;
        this.TenantProvinceItem = this.TenantAddressList[0].TenantProvinceName;
        this.TenantPostCodeItem = this.TenantAddressList[0].TenantPostCode;
      }

      //console.log('TenantAddressList', this.TenantAddressList);
    } catch (error) {
      console.error('Error loading userlogin:', error);
      alert('An error occurred while loading userlogin data. Please try again.');
    } finally {
      this.loading = false;
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  btnClick_onCreateQuotation() {
    this.isOnUpdateQuotation = false;
    this.form.reset();

    //this.form.get('ProductUOM')?.patchValue(this.UomList[0].UomCode);
    this.form.patchValue({ QuotationNo: 'Generate from System'});
    
    // Clear CustomerAddress
    this.CompanyAddressItem = "";
    this.CompanySubDistrictItem = "";
    this.CompanyDistrictItem = "";
    this.CompanyProvinceItem = "";
    this.CompanyPostCodeItem = "";

    // Clear QuotationProduct
    this.SelectedProductList = [];

    this.form.patchValue({ QuotationNo: 'Generate from System' });
    $('#ModalAddEditQuotation').modal('show');
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  async onAddCompany() {
    //await this.LoadCompanyList(); ย้ายไป Load ngOninit เพื่อทำ AutoComplete

    $('#ModalAddCustomerAddress').modal('show');
  }

  async LoadCompanyList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {};

      const response = await this.httpClient.post<any>(this.baseurl + "Company/GetCompany",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.CompanyList = response;

      if (this.CompanyList.length > 0) {
        //
      }

      //console.log('CompanyList', this.CompanyList);
    } catch (error) {
      console.error('Error loading Company:', error);
      alert('An error occurred while loading Company data. Please try again.');
    } finally {
      //this.loading = false;
    }
  }

  onSearchCustomerTextChange(value: string): void {
    this.searchCustomerText = value;
    this.filterCustomerList();
    this.showCustomerDropdown = true;

    const matched = this.CompanyList.some(x =>
      `${x.CompanyCode} - ${x.CompanyName}`.toLowerCase().includes(value.toLowerCase())
    );

    if (!matched) {
      this.selectedCustomerCode = null;
    }
  }

  filterCustomerList(): void {
    const search = (this.searchCustomerText || '').toLowerCase();
    if (!search) {
      this.filteredCustomerList = [...this.CompanyList];
    } else {
      this.filteredCustomerList = this.CompanyList.filter(x =>
        (x?.CompanyCode ?? '').toLowerCase().includes(search) ||
        (x?.CompanyName ?? '').toLowerCase().includes(search)
      );
    }
  }

  async selectCustomer(customer: any): Promise<void> {
    this.searchCustomerText = `${customer.CompanyCode} - ${customer.CompanyName}`;
    this.selectedCustomerCode = customer.CompanyCode;
    this.showCustomerDropdown = false;

    //console.log('Selected Customer:', customer);
    //console.log('Selected CompanyId:', customer.CompanyId);

    this.hidCompanyID = customer.CompanyId;
    this.hidCompanyAbbreviation = customer.CompanyAbbreviation;
    await this.LoadCustomerAddressList(customer.CompanyId);
  }

  onCustomerInputFocus(): void {
    this.filteredCustomerList = this.CompanyList;
    this.showCustomerDropdown = true;
  }

  onCustomerInputBlur(): void {
    setTimeout(() => {
      const match = this.filteredCustomerList.find(x =>
        `${x.CompanyCode} - ${x.CompanyName}`.toLowerCase() === this.searchCustomerText.toLowerCase()
      );

      if (!match) {
        this.searchCustomerText = '';
        this.selectedCustomerCode = null;
      }

      this.showCustomerDropdown = false;
    }, 200);
  }

  async LoadCustomerAddressList(customerId: number | null = null): Promise<void> {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        CompanyID: customerId
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Company/GetCompanyAddress",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.CustomerAddressList = response;

      //console.log('CustomerAddressList', this.CustomerAddressList);
    } catch (error) {
      console.error('Error loading CustomerAddress:', error);
      alert('An error occurred while loading CustomerAddress data. Please try again.');
    } finally {
      //this.loading = false;
    }
  }

  btnClick_onSelectCustomer(item: any): void {
    //console.log('CompanyAddressSelectModel', item);

    this.CompanyAddressItem = this.checkUndefinedString(item.CompanyAddress);
    this.CompanySubDistrictItem = this.checkUndefinedString(item.CompanySubDistrictName);
    this.CompanyDistrictItem = this.checkUndefinedString(item.CompanyDistrictName);
    this.CompanyProvinceItem = this.checkUndefinedString(item.CompanyProvinceName);
    this.CompanyPostCodeItem = this.checkUndefinedString(item.CompanyPostCode);

    this.CompanySubDistrictCodeItem = this.checkUndefinedString(item.CompanySubDistrictCode);
    this.CompanyDistrictCodeItem = this.checkUndefinedString(item.CompanyDistrictCode);
    this.CompanyProvinceCodeItem = this.checkUndefinedString(item.CompanyProvinceCode);

    $('#ModalAddCustomerAddress').modal('hide');
  }

  async btnClick_submitInsertProduct() {
    this.showAddressError = false;
    this.showProductListError = false;

    if (!this.isCompanyAddressValid()) {
      this.showAddressError = true;
      return;
    }

    if (!this.isProductListValid()) {
      this.showProductListError = true;
      return;
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched(); // บังคับให้ทุก field แสดง error ถ้ามี
      return;
    }

    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    //objectjson['QuotationNo'] = "";
    objectjson['QuotationCompanyID'] = this.hidCompanyID;
    objectjson['QuotationCompanyCode'] = this.hidCompanyAbbreviation;
    objectjson['QuotationTenantID'] = this.TenantID;
    objectjson['QuotationProjectSaleID'] = this.checkUndefinedString(this.form.get('QuotationProjectSaleID')?.value);
    objectjson['QuotationValidDate'] = this.checkUndefinedString(this.form.get('QuotationValidDate')?.value);
    objectjson['QuotationCreateBy'] = this.checkUndefinedString(this._EmpCode);

    //console.log('objectjson', objectjson);
    let strjson = JSON.stringify(objectjson);

    try {
      const result = await this.httpClient.post<number>(this.baseurl + "Quotation/InsertQuotation", strjson, httpOptions)
        .toPromise();

      this.isSubmitted = result > 0;
      this.returnInsQuotationID = result;

      if (result > 0) {
        await this.InsertQuotationCompanyAddress(this.returnInsQuotationID);
      }

      //console.log('New QuotationID:', result);

      // await this.LoadQuotatonList("Y");
      //   $('#ModalAddEditQuotation').modal('hide');
      //   $('#ModalQuotationInsertUpdateComplete').modal();          

    } catch (err) {
      console.error("Insert failed", err);
    } finally {
      //this.OnCreating('n');
    }
  }

  async InsertQuotationCompanyAddress(quotationId: number): Promise<void> {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    objectjson['QuotationID'] = quotationId;
    objectjson['QuotationCompanyID'] = this.hidCompanyID;
    objectjson['QuotationCompanyAddress'] = this.checkUndefinedString(this.CompanyAddressItem);
    objectjson['QuotationCompanySubDistrictCode'] = this.checkUndefinedString(this.CompanySubDistrictCodeItem);
    objectjson['QuotationCompanyDistrictCode'] = this.checkUndefinedString(this.CompanyDistrictCodeItem);
    objectjson['QuotationCompanyProvinceCode'] = this.checkUndefinedString(this.CompanyProvinceCodeItem);
    objectjson['QuotationCompanyPostCode'] = this.checkUndefinedString(this.CompanyPostCodeItem);
    objectjson['QuotationCompanyCreateBy'] = this.checkUndefinedString(this._EmpCode);

    //console.log('objectjson', objectjson);
    let strjson = JSON.stringify(objectjson);

    try {
      const result = await this.httpClient.post<boolean>(this.baseurl + "Quotation/InsertQuotationCompanyAddress", strjson, httpOptions)
        .toPromise();

      this.isSubmitted = result;

      if (result === true) {
        await this.InsertQuotationProduct(this.returnInsQuotationID);
      }

      //console.log('New QuotationID:', result);

      // await this.LoadQuotatonList("Y");
      // $('#ModalAddEditQuotation').modal('hide');
      // $('#ModalQuotationInsertUpdateComplete').modal();          

    } catch (err) {
      console.error("Insert failed", err);
    } finally {
      //this.OnCreating('n');
    }
  }

  async InsertQuotationProduct(quotationId: number): Promise<void> {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    this.SelectedProductList.forEach(item => {
      item.QuotationID = this.returnInsQuotationID;
      item.CreateBy = this._EmpCode;
    });

    const strjson = JSON.stringify(this.SelectedProductList);
    try {
      const result = await this.httpClient.post<boolean>(this.baseurl + "Quotation/InsertQuotationProduct", strjson, httpOptions)
        .toPromise();

      this.isSubmitted = result;
      //console.log('New QuotationID:', result);

      await this.LoadQuotatonList("Y");
      $('#ModalAddEditQuotation').modal('hide');
      $('#ModalQuotationInsertUpdateComplete').modal();

    } catch (err) {
      console.error("Insert failed", err);
    } finally {
      //this.OnCreating('n');
    }
  }

  isCompanyAddressValid(): boolean {
    return [
      this.CompanyAddressItem,
      this.CompanySubDistrictItem,
      this.CompanyDistrictItem,
      this.CompanyProvinceItem,
      this.CompanyPostCodeItem
    ].some(x => x && x.trim() !== '');
  }

  isProductListValid(): boolean {
    return this.SelectedProductList && this.SelectedProductList.length > 0;
  }

  async onAddProduct() {
    this.txtSearchProductCode = "";
    this.txtSearchProductName = "";
    this.txtSearchProductLicensePlate = "";
    this.txtSearchProductChassisNo = "";
    await this.LoadProductList("Y");

    $('#ModalProductSelectServiceDeliveryDetail').modal('show');
  }

  async LoadProductList(bySearch: string | null = null) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (bySearch === "Y") {
        this.currentPageNumberPrduct = 1;
      }

      const objectjson = {
        ProductCode: this.checkUndefinedString(this.txtSearchProductCode?.trim()),
        ProductName: this.checkUndefinedString(this.txtSearchProductName?.trim()),
        ProductCategory: this.checkUndefinedString(this.SearchProductCategory?.trim()),
        ProductType: this.checkUndefinedString(this.SearchProductType?.trim()),
        ProductLicensePlate: this.checkUndefinedString(this.txtSearchProductLicensePlate?.trim()),
        ProductChassisNo: this.checkUndefinedString(this.txtSearchProductChassisNo?.trim()),
        rowFetch: environment.PageSize,
        rowOFFSet: ((this.currentPageNumberPrduct - 1) < 0 ? 0 : (this.currentPageNumberPrduct - 1)) * environment.PageSize
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Product/GetProductList",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.ProductList = response;
      this.totalItems = this.ProductList.length;

      if (this.ProductList.length <= 0) {
        this.currentPageNumberPrduct = 0;
      } else {
        if (this.currentPageNumberPrduct == 0) this.currentPageNumberPrduct = 1;
        this.totalItems = Number(this.ProductList[0].itemTotal);
      }

      this.totalPagesProduct = Math.ceil(this.totalItems / environment.PageSize);
    } catch (error) {
      console.error('Error loading product:', error);
      alert('An error occurred while loading product data. Please try again.');
    } finally {
    }
  }

  btnClick_SearchProductList() {
    this.LoadProductList("Y");
  }

  ClearSearchProduct() {
    this.txtSearchProductCode = "";
    this.txtSearchProductName = "";
    this.txtSearchProductLicensePlate = "";
    this.txtSearchProductChassisNo = "";
    this.SearchProductCategory = null;
    this.SearchProductType = null;
    this.LoadProductList("Y");
  }

  OnLoadProductList(target = null) {
    if (target != null) {
      this.currentPageNumberPrduct = target.currentPageNumber;
      this.totalPagesProduct = target.totalPages;
    }

    this.LoadProductList();
  }

  chkallProductclick(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const checkboxes = document.getElementsByName('checkboxproduct') as NodeListOf<HTMLInputElement>;

    checkboxes.forEach(cb => {
      cb.checked = checked;
    });
  }

  btnClick_selectProduct() {
    const checkboxes = document.getElementsByName('checkboxproduct') as NodeListOf<HTMLInputElement>;

    checkboxes.forEach((cb) => {
      if (cb.checked) {
        const id = Number(cb.value); // แปลงเป็น number
        const product = this.ProductList.find(p => p.ProductID === id);

        if (product && !this.SelectedProductList.some(p => p.ProductID === id)) {
          // Use Helper Function
          const newProduct = this.mapProductToQuotationProduct(product);
          this.SelectedProductList.push(newProduct);
          this.onAmountChanged(newProduct);

          console.log('SelectedProductList', this.SelectedProductList);
        }
      }
    });

    ($('#ModalProductSelectServiceDeliveryDetail') as any).modal('hide');
  }

  onAmountChanged(item: any) {
    const amount = Number(item.Amount);

    if (isNaN(amount) || amount < 1) {
      item.Amount = 1;
    } else {
      item.Amount = amount;
    }

    const price = item.ProductPrice ?? 0;
    const bv = item.ProductBV ?? 0;

    item.NetAmountPrice = price * amount;
    item.ProductProfit = item.NetAmountPrice - (bv * amount);
  }

  mapProductToQuotationProduct(product: ProductInfo): QuotationProductInfo {
    return {
      QuotationProductID: 0,
      QuotationID: this.currentQuotationId || 0,
      ProductID: product.ProductID,
      ProductCode: product.ProductCode,
      ProductName: product.ProductName,
      ProductDescription: product.ProductDescription,
      Amount: 1,
      ProductUOM: product.ProductUOM,
      ProductUOMName_TH: product.ProductUOMName,
      ProductUOMName_EN: product.ProductUOMName,
      ProductBV: product.ProductBV,
      ProductPrice: product.ProductPrice,
      NetAmountPrice: product.ProductPrice,
      ProductType: product.ProductType,
      ProductTypeName: product.ProductTypeName,
      ProductCategory: product.ProductCategory,
      ProductCategoryName: product.ProductCategoryName,
      ProductGroup: product.ProductGroup,
      ProductGroupName: product.ProductGroupName,
      ProductVat: product.ProductVat,
      ProductLicensePlate: product.ProductLicensePlate,
      ProductChassisNo: product.ProductChassisNo,
      ProductSerialNo: product.ProductSerialNo,
      CreateDate: '',
      CreateBy: '',
      UpdateDate: '',
      UpdateBy: '',
      FlagDelete: 'N',
      rowFetch: 0,
      rowOFFSet: 0,
      itemTotal: 0
    };
  }

  removeSelectedProduct(index: number) {
    this.SelectedProductList.splice(index, 1);
    //console.log('SelectedProductList', this.SelectedProductList);
  }

  async btnClick_onUpdateQuotation(quotationid) {
    this.isOnUpdateQuotation = true;
    const quotation = this.QuotatonList.find(x => x.QuotationID === quotationid);

    if (quotation) {
      this.currentQuotationId = quotationid;
      //const dateOnly = quotation.QuotationValidDate ? new Date(quotation.QuotationValidDate).toISOString().split('T')[0] : null;
      const dateOnly = quotation.QuotationValidDate ? formatDate(quotation.QuotationValidDate, 'yyyy-MM-dd', 'en-US') : null;

      this.form.patchValue({
        QuotationNo: quotation.QuotationNo,
        QuotationValidDate: dateOnly,
        QuotationProjectSaleID: quotation.QuotationProjectSaleID
      });

      //console.log('QuotationValidDate FormControl:', this.form.get('QuotationValidDate')?.value);
    }

    // Part clear & reload quotationcompanyaddress
    this.CompanyAddressItem = "";
    this.CompanySubDistrictItem = "";
    this.CompanyDistrictItem = "";
    this.CompanyProvinceItem = "";
    this.CompanyPostCodeItem = "";

    this.CompanySubDistrictCodeItem = "";
    this.CompanyDistrictCodeItem = "";
    this.CompanyProvinceCodeItem = "";

    const addressList = await this.LoadQuotationCompanyAddress(quotationid);

    if (addressList.length > 0) {
      // Load Customer Address
      this.CompanyAddressItem = addressList[0].QuotationCompanyAddress;
      this.CompanySubDistrictItem = addressList[0].QuotationCompanySubDistrictName;
      this.CompanyDistrictItem = addressList[0].QuotationCompanyDistrictName;
      this.CompanyProvinceItem = addressList[0].QuotationCompanyProvinceName;
      this.CompanyPostCodeItem = addressList[0].QuotationCompanyPostCode;

      this.CompanySubDistrictCodeItem = addressList[0].QuotationCompanySubDistrictCode;
      this.CompanyDistrictCodeItem = addressList[0].QuotationCompanyDistrictCode;
      this.CompanyProvinceCodeItem = addressList[0].QuotationCompanyProvinceCode;
    }

    // Part clear & load quotationproduct
    this.SelectedProductList = [];

    await this.LoadQuotationProductList(quotationid);
    
    $('#ModalAddEditQuotation').modal('show');
  }

  async LoadQuotationCompanyAddress(quotationid: number | null = null): Promise<any[]> {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        QuotationID: quotationid
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Quotation/GetQuotationCompanyAddress",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.QuotationCompanyAddressList = response;

      if (this.QuotationCompanyAddressList.length > 0) {
        this.hidCompanyID = this.QuotationCompanyAddressList[0].QuotationCompanyID;
      }
      
      return response;

    } catch (error) {
      console.error('Error loading QuotationCompanyAddress:', error);
      alert('An error occurred while loading QuotationCompanyAddress data. Please try again.');
    } finally {
    }
  }

  async LoadQuotationProductList(quotationid: number | null = null) {

    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        QuotationID: quotationid
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Quotation/GetQuotationProduct",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.SelectedProductList = response;

      //console.log('TenantAddressList', this.TenantAddressList);
    } catch (error) {
      console.error('Error loading quotationproduct:', error);
      alert('An error occurred while loading quotationproduct data. Please try again.');
    } finally {
      this.loading = false;
    }

  }


  async btnClick_submitUpdateProduct() {
    this.showAddressError = false;
    this.showProductListError = false;

    if (!this.isCompanyAddressValid()) {
      this.showAddressError = true;
      return;
    }

    if (!this.isProductListValid()) {
      this.showProductListError = true;
      return;
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched(); // บังคับให้ทุก field แสดง error ถ้ามี
      return;
    }

    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    
    var objectjson = {};
        //objectjson['QuotationNo'] = "";
        objectjson['QuotationID'] = this.currentQuotationId;
        objectjson['QuotationCompanyID'] = this.hidCompanyID;
        //objectjson['QuotationCompanyCode'] = this.hidCompanyAbbreviation;
        objectjson['QuotationTenantID'] = this.TenantID;
        objectjson['QuotationProjectSaleID'] = this.checkUndefinedString(this.form.get('QuotationProjectSaleID')?.value);
        objectjson['QuotationValidDate'] = this.checkUndefinedString(this.form.get('QuotationValidDate')?.value);
        objectjson['QuotationUpdateBy'] = this.checkUndefinedString(this._EmpCode);

        //console.log('objectjson', objectjson);
        let strjson = JSON.stringify(objectjson);

        try {
        const result = await this.httpClient.post<boolean>(this.baseurl + "Quotation/UpdateQuotation", strjson, httpOptions)
        .toPromise();

        if (result === true){
          await this.UpdateQuotationCompanyAddress();
        }

        //console.log('New QuotationID:', result);
          
        // await this.LoadQuotatonList("Y");
        //   $('#ModalAddEditQuotation').modal('hide');
        //   $('#ModalQuotationInsertUpdateComplete').modal();          
          
          } catch (err) {
          console.error("Insert failed", err);
        } finally {
          //this.OnCreating('n');
        }

  }

  async UpdateQuotationCompanyAddress(): Promise<void> {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
        objectjson['QuotationID'] = this.currentQuotationId;
        objectjson['QuotationCompanyID'] = this.hidCompanyID;
        objectjson['QuotationCompanyAddress'] = this.checkUndefinedString(this.CompanyAddressItem);
        objectjson['QuotationCompanySubDistrictCode'] = this.checkUndefinedString(this.CompanySubDistrictCodeItem);
        objectjson['QuotationCompanyDistrictCode'] = this.checkUndefinedString(this.CompanyDistrictCodeItem);
        objectjson['QuotationCompanyProvinceCode'] = this.checkUndefinedString(this.CompanyProvinceCodeItem);
        objectjson['QuotationCompanyPostCode'] = this.checkUndefinedString(this.CompanyPostCodeItem);
        objectjson['QuotationCompanyCreateBy'] = this.checkUndefinedString(this._EmpCode);

        //console.log('objectjson', objectjson);
        let strjson = JSON.stringify(objectjson);

        try {
        const result = await this.httpClient.post<boolean>(this.baseurl + "Quotation/UpdateQuotationCompanyAddress", strjson, httpOptions)
        .toPromise();

        this.isSubmitted = result;

        if (result === true){
          await this.UpdateQuotationProduct();
        }

        //console.log('New QuotationID:', result);
          
        // await this.LoadQuotatonList("Y");
        // $('#ModalAddEditQuotation').modal('hide');
        // $('#ModalQuotationInsertUpdateComplete').modal();          
          
        } catch (err) {
            console.error("Insert failed", err);
        } finally {
          //this.OnCreating('n');
        }
  }

  async UpdateQuotationProduct(): Promise<void> {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      console.error('No valid token');
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    this.SelectedProductList.forEach(item => {
      item.QuotationID = this.currentQuotationId;
      item.CreateBy = this._EmpCode;
  });

    const strjson = JSON.stringify(this.SelectedProductList);
      try {
        const result = await this.httpClient.post<boolean>(this.baseurl + "Quotation/UpdateQuotationProduct", strjson, httpOptions)
        .toPromise();

        this.isSubmitted = result;
        //console.log('New QuotationID:', result);
          
        await this.LoadQuotatonList("Y");
        $('#ModalAddEditQuotation').modal('hide');
        $('#ModalQuotationInsertUpdateComplete').modal();          
          
      } catch (err) {
        console.error("Insert failed", err);
      } finally {
          //this.OnCreating('n');
      }
  }

  chkallQuotationclick(target) {
    var check = $(target.currentTarget).is(":checked");

    $('[name="checkboxquotation"]').prop('checked', check);
  }

  async btnClick_onDeleteQuotationList() {
    if (confirm("Are you sure to delete this Quotation?")) {
  
      var checkkedquotation = $('[name="checkboxquotation"]:checked');
      let num = checkkedquotation.length;
      let listQuotationModel = []; //listProductModel
        
  
      for (var i = 0; i < num; i++) {
        var Quotationcurrent = <HTMLInputElement>checkkedquotation[i]; // Productcurrent
        let quotationInfo = new QuotationInfo; // productInfo
        quotationInfo.QuotationID = parseInt(Quotationcurrent.value); //companycontactInfo // ProductID
  
          var currentQuotation = this.QuotatonList.filter(x => { return x.QuotationID == quotationInfo.QuotationID }); // currentProduct
          var isOwner = (currentQuotation[0].QuotationCreateBy == this._EmpCode);
  
          //console.log(" Delete id = " + quotationInfo.QuotationID + " \n Role = " + this._RoleCode + " \n Is Owner? = " + isOwner);
          if (isOwner || (this._RoleCode !== null && this._RoleCode !== "")) {
            listQuotationModel.push(quotationInfo);
            } else
          {
            //this.titlemodal = ""
            //this.detailmodal = "Cannot delete company : <b>" + currentCompany[0].CompanyName + "</b>. please contact " + currentCompany[0].CompanyCreateByDisplay;
            this.detailmodal = "You don't have permission to delete this company. Please contact" + currentQuotation[0].QuotationCreateBy;
            $('#ModalError .modal-header').text("Information");
            $('#ModalError .modal-header').addClass('bg-blue');
            $('#ModalError').modal();
  
            listQuotationModel = [];
            break; //break loop
          }
        }
  
        if (listQuotationModel.length > 0) {
          await this.deleteQuotationList(listQuotationModel);
          await this.DeleteQuotationCompanyAddressList(listQuotationModel);
          await this.DeleteQuotationProduct(listQuotationModel);
        }


  
      }
  }

  async deleteQuotationList(listQuotationModel) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Send to delete
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
          })
        };
       
  
        let strjsonCompGroupInfo = JSON.stringify(listQuotationModel);
        console.log('strjsonCompGroupInfo', strjsonCompGroupInfo)
  
        this.httpClient.post<QuotationInfo[]>(this.baseurl + "Quotation/DeleteListQuotation", strjsonCompGroupInfo, httpOptions)
          .toPromise()
          .then(data => {
            console.log("delete quotation list successfully");
            //$('#ModalDeleteQuotationComplete').modal('show');
            //this.onModalClose();
            //this.LoadQuotatonList("Y");
          })
          .catch(err => {
            console.log(err);
          });
      }
  }

  async DeleteQuotationCompanyAddressList(listQuotationModel) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Send to delete
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
          })
        };
       
  
        let strjsonCompGroupInfo = JSON.stringify(listQuotationModel);
        console.log('strjsonCompGroupInfo', strjsonCompGroupInfo)
  
        this.httpClient.post<QuotationCompanyAddressInfo[]>(this.baseurl + "Quotation/DeleteListQuotationCompanyAddress", strjsonCompGroupInfo, httpOptions)
          .toPromise()
          .then(data => {
            console.log("delete quotationcompany list successfully");
            //$('#ModalDeleteQuotationComplete').modal('show');
            //this.onModalClose();
            //this.LoadQuotatonList("Y");
          })
          .catch(err => {
            console.log(err);
          });
      }
  }

  async DeleteQuotationProduct(listQuotationModel) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //Send to delete
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
          })
        };
       
  
        let strjsonCompGroupInfo = JSON.stringify(listQuotationModel);
        console.log('strjsonCompGroupInfo', strjsonCompGroupInfo)
  
        this.httpClient.post<QuotationProductInfo[]>(this.baseurl + "Quotation/DeleteListQuotationProduct", strjsonCompGroupInfo, httpOptions)
          .toPromise()
          .then(data => {
            console.log("delete quotationcompany list successfully");
            $('#ModalDeleteQuotationComplete').modal('show');
            //this.onModalClose();
            this.LoadQuotatonList("Y");
          })
          .catch(err => {
            console.log(err);
          });
      }
  }



  async btnClick_onPrintQuotation(quotationid: number) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        QuotationID: quotationid,
        ParamEmployeeCode: this._EmpCode?.trim(),
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Quotation/GetQuotationModelForPrint",
        JSON.stringify(objectjson), httpOptions).toPromise();

      // Generate PDF from the response data
      await this.generateQuotationPDF(response);

    } catch (error) {
      console.error('Error loading QuotationModelForPrint:', error);
      alert('An error occurred while loading QuotationModelForPrint data. Please try again.');
    } finally {
    }
  }



  async generateQuotationPDF(quotationData: any) {
    try {
      // Create a temporary div for the PDF content
      const pdfContainer = document.createElement('div');
      pdfContainer.style.position = 'absolute';
      pdfContainer.style.left = '-9999px';
      pdfContainer.style.width = '800px';
      pdfContainer.style.backgroundColor = 'white';
      pdfContainer.style.padding = '20px';
      pdfContainer.style.fontFamily = 'Arial, sans-serif';
      pdfContainer.style.fontSize = '12px';

      // Generate HTML content for the quotation
      pdfContainer.innerHTML = this.generateQuotationHTML(quotationData);

      document.body.appendChild(pdfContainer);

      // Generate PDF
      const canvas = await html2canvas(pdfContainer, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');

      const imgWidth = 210; // A4 width in mm
      const pageHeight = 295; // A4 height in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Save the PDF
      const fileName = `Quotation_${quotationData.QuotationNo || 'document'}.pdf`;
      pdf.save(fileName);

      // Clean up
      document.body.removeChild(pdfContainer);

    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('An error occurred while generating the PDF. Please try again.');
    }
  }

  generateQuotationHTML(quotationData: any): string {
    const formatDate = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      //return date.toLocaleDateString('th-TH');
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    const formatCurrency = (amount: number) => {
      if (amount === null || amount === undefined) return '0.00';
      return amount.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const tenantAddress = quotationData.QuotationForPrintAddressTenant || {};
    const companyAddress = quotationData.QuotationForPrintAddressCompany || {};
    const products = quotationData.QuotationForPrintProductList || [];

    return `
      <div style="max-width: 800px; margin: 0 auto; padding-top: 20px;padding-bottom: 20px;padding-left: 40px;padding-right: 40px;">
        <!-- Header -->
        <div style="text-align: left; margin-bottom: 30px; border-bottom: 2px solid #000; padding-bottom: 20px;">
          <h1 style="margin: 0; color: #333;">Quotation</h1>
        </div>

        
        <!-- Quotation Header -->
        <div style="margin-bottom: 20px;">
          <div><strong>Date:</strong> ${formatDate(quotationData.QuotationCreateDate)}</div>
          <div><strong>Quote No:</strong> ${quotationData.QuotationNo || ''}</div>
          <div><strong>Valid Until:</strong> ${formatDate(quotationData.QuotationValidDate)}</div>
        </div>

        <!-- Quotation Details -->
        <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
          
          <!-- Tenant Info -->
          <div style="text-align: left;" class="w-100">
            <div style="font-weight: bold; font-size: 14px; margin-bottom: 5px;text-decoration: underline;">ALDENAIRE & PARTNERS</div>
            <div>${quotationData.QuotationTenantName_EN || ''}</div>
            <div>${tenantAddress.QuotationAddress || ''}</div>
            <div>แขวง${tenantAddress.QuotationSubDistrict || ''} เขต${tenantAddress.QuotationDistrict || ''}</div>
            <div>${tenantAddress.QuotationProvince || ''} ${tenantAddress.QuotationPostCode || ''}</div>
          </div>

          <!-- Company Info -->
          <div style="text-align: left;" class="w-100">
            <div style="font-weight: bold; font-size: 14px; margin-bottom: 5px;text-decoration: underline;">QUOTATION FOR</div>
            <div>${quotationData.QuotationCompanyName || ''}</div>
            <div>${companyAddress.QuotationAddress || ''}</div>
            <div>แขวง${companyAddress.QuotationSubDistrict || ''} เขต${companyAddress.QuotationDistrict || ''}</div>
            <div>${companyAddress.QuotationProvince || ''} ${companyAddress.QuotationPostCode || ''}</div>
          </div>
        </div>

        <!-- Product Table -->
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <thead>
            <tr style="background-color: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">No</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Item</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">Quantity</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: right;">Unit Price</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: right;">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            ${products.map((product: any, index: number) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px;">${product.QuotationProductCode || ''}</td>
                <td style="border: 1px solid #ddd; padding: 8px;">
                  <div><strong>${product.QuotationProductName || ''}</strong></div>
                  <div style="font-size: 11px; color: #666;">${product.QuotationProductDescription || ''}</div>
                </td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${product.QuotationProductAmount || 0}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">${formatCurrency(product.QuotationProductPrice || 0)}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">${formatCurrency(product.QuotationProductNetAmountPrice || 0)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <!-- Summary -->
        <div style="display: flex; justify-content: flex-end;">
          <div style="width: 300px;">
            <div style="display: flex; justify-content: space-between; padding: 5px 0; border-bottom: 1px solid #ddd;">
              <span>Subtotal:</span>
              <span>${formatCurrency(quotationData.QuotationForPrintProductSubtotal || 0)}</span>
            </div>
            <div style="display: flex; justify-content: space-between; padding: 5px 0; border-bottom: 1px solid #ddd;">
              <span>Tax:</span>
              <span>${formatCurrency(quotationData.QuotationForPrintProductTax || 0)}</span>
            </div>
            <div style="display: flex; justify-content: space-between; padding: 5px 0; border-bottom: 1px solid #ddd;">
              <span>Discount:</span>
              <span>${formatCurrency(quotationData.QuotationForPrintProductDiscount || 0)}</span>
            </div>
            <div style="display: flex; justify-content: space-between; padding: 5px 0; font-weight: bold; font-size: 14px;">
              <span>Total:</span>
              <span>${formatCurrency((quotationData.QuotationForPrintProductTotal || quotationData.QuotationForPrintProductSubtotal || 0))}</span>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div style="margin-top: 40px; text-align: left; color: #000;">
          <p class="m-0 p-0" style="font-size: 14px;font-weight: bold;">THANK YOU FOR YOUR BUSINESS</p>
          <p class="m-0 p-0">If you have any question, please contact us.</p>
        </div>
      </div>
    `;
  }

  async LoadProjectSaleList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        ProjectSaleAssignTo: this.checkUndefinedString(this._EmpCode)
      };

      const response = await this.httpClient.post<any>(this.baseurl + "ProjectSale/GetProjectSaleForSelectDdl",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.ProjectSaleList = response;

      //console.log('ProjectSaleList', this.ProjectSaleList);
    } catch (error) {
      console.error('Error loading ProjectSale:', error);
      alert('An error occurred while loading ProjectSale data. Please try again.');
    } finally {
      //this.loading = false;
    }
  }

  getTotalAmount(): number {
  return this.SelectedProductList?.reduce((sum, item) => sum + (item.Amount || 0), 0) || 0;
}

  getTotalNetAmountPrice(): number {
  return this.SelectedProductList?.reduce((sum, item) => sum + (item.NetAmountPrice || 0), 0) || 0;
}

  async LoadAssetTypeList(catcode: string | null = null, typecode: string | null = null) {
    //console.log('catcode & typecode', catcode + ' ' + typecode);
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {
        AssetCategoryCode: catcode,
        AssetTypeCode: typecode
      };

      const response = await this.httpClient.post<any>(this.baseurl + "AssetType/GetAssetType",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.AssetTypeList = response;
      this.AssetTypeListFromSearchProduct = response

      if (this.AssetTypeList.length > 0) {
        this.ProductGroupShow = this.AssetTypeList[0].AssetGroupName;
        this.ProductCategoryShow = this.AssetTypeList[0].AssetCategoryName;
        this.ProductTypeShow = this.AssetTypeList[0].AssetTypeName;
      }
      
      return response;

    } catch (error) {
      console.error('Error loading QuotationCompanyAddress:', error);
      //alert('An error occurred while loading QuotationCompanyAddress data. Please try again.');
    } finally {
    }
  }

  async LoadAssetCategoryList() {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      const objectjson = {};

      const response = await this.httpClient.post<any>(this.baseurl + "AssetType/GetAssetCategory",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.AssetCategoryList = response;

      if (this.AssetCategoryList.length > 0) {
        
      }
      
      return response;

    } catch (error) {
      console.error('Error loading AssetCategoryList:', error);
      //alert('An error occurred while loading QuotationCompanyAddress data. Please try again.');
    } finally {
    }
  }

  async onProductCategoryChange(value) {
    let catcode = value;

    await this.LoadAssetTypeList(catcode, "");
  }

  // Code Auto Complete Event of Search Customer (CompanyList)
  onCustomerAutoSearchChange(value: string) {
    this.searchCustomerAutoText = value;
    this.filterCustomerAutoList();
    this.showCustomerAutoDropdown = true;
  }

  filterCustomerAutoList(): void {
    const search = (this.searchCustomerAutoText || '').toLowerCase();
    this.filteredCustomerAutoList = this.CompanyList.filter(x =>
      (`${x.CompanyCode} - ${x.CompanyName}`.toLowerCase().includes(search)) ||
      (x.CompanyCode || '').toLowerCase().includes(search) ||
      (x.CompanyName || '').toLowerCase().includes(search)
    );
  }

  onCustomerAutoFocus() {
    this.filteredCustomerAutoList = this.CompanyList;
    this.showCustomerAutoDropdown = true;
  }

  onCustomerAutoBlur() {
    setTimeout(() => {
      this.showCustomerAutoDropdown = false;
      const matched = this.CompanyList.find(x =>
        `${x.CompanyCode} - ${x.CompanyName}`.toLowerCase() === (this.searchCustomerAutoText || '').toLowerCase()
      );

    if (matched) {
      this.selectedAutoCustomer = matched;
      this.txtSearchCompanyCode = matched.CompanyCode; // ✅ โอนค่าที่ต้องการจริงไปยัง ngModel เดิม
    } else {
      this.searchCustomerAutoText = '';
      this.selectedAutoCustomer = null;
      this.txtSearchCompanyCode = ''; // เคลียร์ค่าหากพิมพ์เอง
      }
    }, 200);
  }

  selectAutoCustomer(customer: any) {
    this.selectedAutoCustomer = customer;
    this.searchCustomerAutoText = `${customer.CompanyCode} - ${customer.CompanyName}`;
    this.txtSearchCompanyCode = customer.CompanyCode; // ✅ เซ็ตค่าที่จะถูกส่งออกจริง
    this.showCustomerAutoDropdown = false;
  }
  // Code Auto Complete Event of Search Customer (CompanyList)

}


